module.exports = __webpack_public_path__ + "img/img7.ca5e9934.png";